import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from 'src/app/shared/services/globals';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.css']
})
export class AboutUsComponent implements OnInit {


  constructor(private router: Router,public global: Globals,translate: TranslateService) {
    translate.setDefaultLang('AR');
  }

  ngOnInit() {
  }

}
